import { render, staticRenderFns } from "./GeneralSettingContactTelephone.vue?vue&type=template&id=0be0e604&"
import script from "./GeneralSettingContactTelephone.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingContactTelephone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports